import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Navigation from '../Navigation/Navigation';
import RideForm from './RideForm';
import Footer from '../General/Footer';
import AlertComponent from '../Alert/alert';
import { getRide } from '../../actions/rideManagementActions';

class AddRide extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ride: undefined,
            pageTitle: "Ajoutez votre balade",
            alert: {
                show: false,
                message: "",
                type: ""
            }
        }
        this.handleDismiss = this.handleDismiss.bind(this);
    }

    componentDidMount() {
        if (this.props.location && this.props.location.state && this.props.location.state.rideId) {
            getRide({ id: this.props.location.state.rideId }).then((ride) => {
                this.setState({
                    ride: ride.data,
                    pageTitle: "Modify Your Ride"
                })
            }).catch((err) => {
                console.log("err: ", err);
            })
        }
    }

    handleDismiss() {
        this.setState({ alert: { ...this.state.alert, show: false } });
    }

    render() {
        const { state, props } = this;
        if (!props.user.userProfile) {
            return <Redirect to="/" />
        }
        return (
            <div className="ridepage__main">
                <Navigation auth={props.auth} />
                <AlertComponent type={this.state.alert.type} message={this.state.alert.message} show={this.state.alert.show} handleDismiss={this.handleDismiss} />
                <div className="createride__hero">
                    <h1>{state.pageTitle}</h1>
                </div>
                <RideForm ride={state.ride} user={props.user} />
                <Footer />
            </div>
        )
    }
}

export default connect((state) => {
    return { user: state.reducerUser }
})(AddRide);